<script>
import $ from "jquery";

export default {
  name: "BlockPlezi",

  mounted() {
    let blk = document.getElementById('block-plezi-script');
    let plz = document.createElement('script');
    plz.setAttribute('async', 'async');
    plz.setAttribute('src', 'https://api.plezi.co/api/v1/web_forms/scripts?tenant_id=5e28195df420875abb01b927&form_id=61add60ad59cbc4218a6c0c5&form_version=3&content_web_form_id=61adda89d59cbc41c4a6c0bb&plz_lang=fr');
    $("#block-jsplezi").append(plz);
    $("#block-jsplezi").css({
      "margin": "10px 10% 10px"
    });

    let mediaQuery1 = window.matchMedia('(min-width: 1024px)')
    if (mediaQuery1.matches) {
      $("#block-jsplezi").css({
        "margin": "10px 14% 10px"
      });
    }

  },
}
</script>
